import React, { Fragment } from 'react';
import {FacebookShareButton, PinterestShareButton} from 'react-share';
import PropTypes from 'prop-types';
import Link from 'redux-first-router-link';
import Socials from './Socials';
import OutboundLink from '../common/OutboundLink';
import HeaderBackground from './HeaderBackground';
import SearchForm from '../Search/SearchForm';
import {
  segmentTrackPage, segmentTrackEvent
} from '../../utils';

const handleClick = (e) => {
  const { target } = e;
  const targetTagName = target.tagName.toLowerCase();
  let trackableElement = target;
  let innerHTML = '';
  if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
    if (targetTagName === 'img') {
      trackableElement = target.parentNode;
      innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
    } else {
      ({ innerHTML } = target);
    }
  }
  const destinationUrl = trackableElement.getAttribute('href');
  const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
  const articleClickedTracker = {
    destinationUrl,
    module: 'header-sponsor-logo',
    hypercontext: innerHTML, // need to handle this more elegantly
    category: linkType,
    linkType,
    label: destinationUrl,
  };
  segmentTrackEvent('article_clicked', articleClickedTracker);
}

const metaData = {
  "title": "PureWow 20 in ’20",
  "description": "In collaboration with Citi, PureWow is spotlighting 20 leaders who are working to make a meaningful impact in 2020 across the pillars of equality, sustainability and workforce development.",
  "url": "https://www.purewow.com/20-in-20",
  "image": {
    "facebook": "https://static.cdn.gallerymediagroup.com/citi20in20/shares/FB.jpg",
    "pinterest": "https://static.cdn.gallerymediagroup.com/citi20in20/shares/Pin.gif",
  },
  "sponsoredLogo": "https://static.cdn.gallerymediagroup.com/citi20in20/logos/citi-logo.svg",
}

const { sponsoredLogo, title } = metaData;

const HeaderFixed = ({
  isMobile,
  HeaderLogo,
  HeaderMenuButton,
  standardArticleTracker,
}) => (

  <div className="header-scrolling">
    <HeaderBackground />
    <div className="header-contents">
      <div className="header-content">
        {HeaderLogo}
        <div className="header-scrolling-article-hed"></div>
      </div>
      <div className="header-content">
        <ul>
              {sponsoredLogo &&
              <li>
                <a onClick={(e) => handleClick(e)} href="https://www.citigroup.com/citi/about/its-about-time/" target="_blank"><img className="sponsored-logo" src={sponsoredLogo} /></a>
              </li>
              }
              <li>
                <div className="btn-social-wrapper">
                  <FacebookShareButton
                    url={metaData.url}
                    title={metaData.title}
                    description={metaData.description}
                    picture={metaData.image.facebook}
                    className="btn-social btn-social__color--facebook social_click"
                    onClick={() => analytics.track('Social Share', {action_type: 'facebook'})}>
                    <span className="icon-facebook btn-social__icon"></span>
                    <span className="btn-social__text">&nbsp;SHARE</span>
                  </FacebookShareButton>
                </div>
              </li>
              <li>
                <div className="btn-social-wrapper">
                  <PinterestShareButton
                    url={metaData.url}
                    media={metaData.image.pinterest}
                    description={metaData.description}
                    windowWidth={1000}
                    windowHeight={730}
                    className="btn-social btn-social__color--pinterest social_click"
                    onClick={() => analytics.track('Social Share', {action_type: 'pinterest'})}>
                    <span className="icon-pinterest btn-social__icon"></span>
                    <span className="btn-social__text">&nbsp;PIN IT</span>
                  </PinterestShareButton>
                </div>
              </li>
            </ul>
      </div>
    </div>
  </div>
  // <div className="header-fixed">
  //   <HeaderBackground />

  //   <div className="header-contents">
  //     <div className="header-content header-content-start">
  //       {isMobile ? HeaderLogo : HeaderMenuButton}
  //     </div>
  //     {!isMobile
  //       && <div className="header-content header-content-mid">
  //         {HeaderLogo}
  //       </div>
  //     }
  //     <div className="header-content header-content-end">
  //       {isMobile ? (
  //         <Fragment>
  //           <OutboundLink className="header-icon header-icon-instagram icon-instagram" href="https://www.instagram.com/one37pm" />
  //           {HeaderMenuButton}
  //         </Fragment>
  //       ) : (
  //         <Fragment>
  //           <Socials parent="header" appendedChildren={<SearchForm cssClass="social" canCollapse={true} />} standardArticleTracker={standardArticleTracker} />
  //         </Fragment>
  //       )}
  //     </div>
  //   </div>
  // </div>
);

HeaderFixed.propTypes = {
  isMobile: PropTypes.bool,
  HeaderLogo: PropTypes.node,
  HeaderMenuButton: PropTypes.node,
};

export default HeaderFixed;
